import { RefObject, useRef, useState } from "react";
import { useEffectOnce } from "./useEffectOnce";

export function useResizeObserver<T extends HTMLElement>(
  initialValue?: T
): [RefObject<T>, DOMRect | null] {
  const ref = useRef<T>(initialValue ?? null);
  const [size, setSize] = useState<DOMRect | null>(null);

  useEffectOnce(() => {
    if (ref.current != null) {
      new ResizeObserver(([current]) =>
        setSize(current.target.getBoundingClientRect())
      ).observe(ref.current);
    }
  });

  return [ref, size];
}
